import React, { memo, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import Sidebar from "../Layouts/Sidebar";
import Topbar from "./Topbar";
import Heading from "./Heading";
import Loader from "../Components/UI/Loader";
import useSocketContext from "../context/socketContext";

const Master = () => {
  const { isLoading } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.user);
  const { _socket } = useSocketContext();

  useEffect(() => {
    _socket.connect();
    _socket.emit("join-room", user?.user_id);

    return () => {
      _socket.emit("leave-room", user?.user_id);
      _socket.disconnect();
    };
  }, [_socket, user?.user_id]);

  return (
    <>
      <Topbar />
      <Sidebar />

      <section className="page-wrapper">
        <div className="page-content">
          <Heading />
          <div className="card">
            <Outlet />
          </div>
        </div>
      </section>
      {isLoading && <Loader />}
    </>
  );
};

export default Master;
